"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasRAF = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined;
var prevTime = 0;
var onNextFrame = hasRAF ? function (callback) {
  return window.requestAnimationFrame(callback);
} : function (callback) {
  var currentTime = Date.now();
  var timeToCall = Math.max(0, 16.7 - (currentTime - prevTime));
  prevTime = currentTime + timeToCall;
  setTimeout(function () {
    return callback(prevTime);
  }, timeToCall);
};
exports.default = onNextFrame;